import type { FaireProductEntity } from "../../entity_types/product";

export const p_2gsdpcnbjn: FaireProductEntity = {
  token: "p_2gsdpcnbjn",
  type: "product",
  name: "Dinosaur Surprise Bath Bomb",
  brandToken: "b_ftqh3zqnue",
  brandName: "Nature's Love Product",
  imageUrl:
    "https://cdn.faire.com/fastly/3c86a878160e18453bd4c422790cb3e30ba8510d355cca19efd7a59e9670cdc0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a28f6cd7adc2a1766b27f1371059ae022bcc15a9edc5f0cde511cf6894bed919.jpeg",
  ],
  priceDollars: 3.5,
  description:
    "Embark on a prehistoric adventure with the Dinosaur Surprise Bath Bomb from Nature's Love Product. This family-owned brand is committed to delivering natural, organic bath and body items that nourish your skin and overall wellness. Our Dinosaur Surprise Bath Bomb, like all our products, is free from gluten, corn, parabens, and phthalates. Infused with organic oils and skin-loving ingredients, it transforms your bath into a fizzy, fun, and skin-friendly experience. Choose Nature's Love Product for skincare that's truly nature's way.",
  tags: [],
  msrpDollars: 7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:48:33.454Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
